import * as TypeGraphQL from "type-graphql";
export var InstitutionalHoldingScalarFieldEnum;
(function (InstitutionalHoldingScalarFieldEnum) {
    InstitutionalHoldingScalarFieldEnum["id"] = "id";
    InstitutionalHoldingScalarFieldEnum["symbol"] = "symbol";
    InstitutionalHoldingScalarFieldEnum["institutionName"] = "institutionName";
    InstitutionalHoldingScalarFieldEnum["filingDate"] = "filingDate";
    InstitutionalHoldingScalarFieldEnum["reportDate"] = "reportDate";
    InstitutionalHoldingScalarFieldEnum["sharesHeld"] = "sharesHeld";
    InstitutionalHoldingScalarFieldEnum["marketValue"] = "marketValue";
    InstitutionalHoldingScalarFieldEnum["percentOfClass"] = "percentOfClass";
    InstitutionalHoldingScalarFieldEnum["changeShares"] = "changeShares";
    InstitutionalHoldingScalarFieldEnum["changePercent"] = "changePercent";
    InstitutionalHoldingScalarFieldEnum["metadata"] = "metadata";
    InstitutionalHoldingScalarFieldEnum["createdAt"] = "createdAt";
    InstitutionalHoldingScalarFieldEnum["updatedAt"] = "updatedAt";
})(InstitutionalHoldingScalarFieldEnum || (InstitutionalHoldingScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(InstitutionalHoldingScalarFieldEnum, {
    name: "InstitutionalHoldingScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=InstitutionalHoldingScalarFieldEnum.js.map